<template>
  <VNavigationDrawer
    v-model="isOpen"
    location="end"
    temporary
    width="480"
    class="notification-drawer"
  >
    <NotificationPanel
      :notifications="notifications"
      :loading="isFetching"
      closeIcon="close"
      @close="close"
      @delete-all="deleteAll"
      @mark-all-read="markAllRead"
      @delete="deleteOne"
      @open="openNotification"
    />
  </VNavigationDrawer>
</template>

<script lang="ts" setup>
import { VNavigationDrawer } from 'vuetify/components'
import NotificationPanel from '@/modules/Notification/components/NotificationPanel/NotificationPanel.vue'
import { useNotificationPanel } from '@/modules/Notification/composables/useNotificationPanel'

defineOptions({
  name: 'NotificationDrawer',
})

const {
  isOpen,
  notifications,
  isFetching,
  close,
  deleteAll,
  markAllRead,
  deleteOne,
  openNotification,
} = useNotificationPanel()
</script>

<style scoped lang="scss">
.notification-drawer {
  :deep(.v-navigation-drawer__content) {
    overflow: hidden;
  }
}
</style>
